export default __webpack_public_path__ + "static/media/btn_deleguer_droits.8f2516dc.svg";